import type { NotificationTypeEnum } from "types/domain";

export const NotificationFilterValue = {
  ALL: "all",
  UNREAD: "unread",
  SESSION_REMINDER: "SESSION_REMINDER",
  SESSION_CANCELLED: "SESSION_CANCELLED",
  SESSION_UPDATED: "SESSION_UPDATED",
  SESSION_REPORT_SUBMITTED: "SESSION_REPORT_SUBMITTED",
  SESSION_REPORT_UPDATED: "SESSION_REPORT_UPDATED",
  STAFF_CHECKED_IN: "STAFF_CHECKED_IN",
  STAFF_CHECKED_OUT: "STAFF_CHECKED_OUT",
  LEAVE_REQUESTED: "LEAVE_REQUESTED",
  LEAVE_APPROVED: "LEAVE_APPROVED",
  LEAVE_REJECTED: "LEAVE_REJECTED",
  GENERAL: "GENERAL",
} as const;

export type NotificationFilter =
  (typeof NotificationFilterValue)[keyof typeof NotificationFilterValue];

export const isNotificationTypeFilter = (
  value: NotificationFilter
): value is NotificationTypeEnum => {
  return (
    value !== NotificationFilterValue.ALL &&
    value !== NotificationFilterValue.UNREAD
  );
};
